import { useState, useEffect, useRef, useContext, Suspense } from 'react';
import { TbArrowRotaryFirstLeft } from 'react-icons/tb';
import { MdFlipToFront, MdOutlineVideoCameraBack } from 'react-icons/md';
import AppContext from '../../components/context/AppContext';

import ThreeD from './scene';

function Loading() {
 return <h3 className='flex items-center justify-center text-white text-hp9 font-poppins  '>Loading Model, Please wait...</h3>;
}

function TreeD() {
 const { setPageNumber, langContext } = useContext(AppContext);

 const [cameraButton, setCameraButton] = useState('cameraA');
 const [textureButton, setTextureButton] = useState('/3D/mur.jpg');
 const [floorButton, setFloorButton] = useState('roof');

 const TreedRef = useRef();

 const optionsTreed = {
  root: null,
  rootMargin: '0px',
  threshold: 0.05,
 };

 useEffect(() => {
  let observerTreed = new IntersectionObserver(entries => {
   // //console.log("extRef :", entries[0].isIntersecting);
   if (entries[0].isIntersecting) {
    setPageNumber(6);
   }
  }, optionsTreed);
  observerTreed.observe(TreedRef.current);
 }, []);

 return (
  <div id='idInteractive' className='mainContent data-scroll-section h-full  xbg-red-500  flex items-center text-white justify-end md:justify-center flex-col md:flex-row px-[8vw]  md:px-[10vw]' ref={TreedRef}>
   <section id='idThreeDText' className=' bg-backbg sbg-blue-500 xg-red-500  flex flex-col  justify-center text-center items-center   md:w-1/2 md:h-full pt-[18vh]  md:pt-[8vh]'>
    <div className='xg-green-500 flex items-start flex-col justify-start text-start gap-[0.4rem] '>
     <h2 className=' text-hp3 w-full text-main leading-[0vh] py-[1em]'>{langContext == 'en' ? 'HOUSE' : 'CONFIGURATEUR'}</h2>
     <h2 className=' text-hp3 w-full text-main leading-[0vh] pb-[1em] md:pb-[0.75em]'>{langContext == 'en' ? 'CONFIGURATOR' : 'DE MAISON'}</h2>
     <p className='xg-red-800 text-hp6 tracking-[0.1vw] xg-blue-800 w-full leading-[0vh] pb-[1em]  md:pb-[4em] font-poppins  '>
      INTERACTIVE 3D
      <span className='text-hp9 pl-[10px]'>( THREEJS )</span>
     </p>

     <p className='g-red-800 text-hp10 tracking-[0.1vw] xg-blue-800 w-full   pb-[0em] font-poppins  '>{langContext == 'en' ? 'Interact & Rotate the model to Explore the 360° view .' : 'Interagissez & faites pivoter le modèle pour explorer la vue à 360°.'}</p>

     <div className='xg-orange-500 flex flex-row items-center justify-center max-w-lg text-backbg pt-[2vh] md:pt-[4vh] pb-[2vh] text-[10px] md:text-sm'>
      <div className='flex items-center justify-center text-center xg-red-800 w-full  gap-1 pr-[5px]'>
       <div className='bg-gray-500 w-[22px] h-[22px] flex items-center justify-center rounded-full'>
        <MdFlipToFront className='w-[16px] h-[16px] mx-[4px] flex items-center justify-center text-white ' />
       </div>
       <label htmlFor='selectTexture' className='visually-hidden'>
        Texture
       </label>
       <select
        id='selectTexture'
        className=' md:flex bg-backbg text-white buttonsStyle'
        value={textureButton}
        onChange={e => {
         setTextureButton(e.target.value);
        }}
       >
        <option value='/3D/mur.jpg'>Texture A</option>
        <option value='/3D/mur2.jpg'>Texture B</option>
       </select>
      </div>

      <div className='flex items-center justify-center text-center xg-red-800 w-full gap-1 pr-[5px] '>
       <div className='bg-blue-500 w-[22px] h-[22px] flex items-center justify-center rounded-full '>
        <MdOutlineVideoCameraBack className='w-[16px] h-[16px] mx-[4px] flex items-center justify-center text-white ' />
       </div>
       <label htmlFor='selectCamera' className='visually-hidden'>
        Camera
       </label>
       <select
        id='selectCamera'
        className=' md:flex bg-backbg text-white buttonsStyle '
        value={cameraButton}
        onChange={e => {
         setCameraButton(e.target.value);
        }}
       >
        <option value='cameraA'>Camera 1</option>
        <option value='cameraB'>Camera 2</option>
       </select>
      </div>
      <div className='flex items-center justify-center text-center xg-red-800 w-full  gap-1 pr-[5px]'>
       <div className='bg-orange-500 w-[22px] h-[22px] flex items-center justify-center rounded-full'>
        <TbArrowRotaryFirstLeft className='w-[16px] h-[16px] mx-[4px] flex items-center justify-center text-white ' />
       </div>
       <label htmlFor='selectFloor' className='visually-hidden'>
        Floor
       </label>
       <select
        id='selectFloor'
        className=' md:flex bg-backbg text-white buttonsStyle'
        value={floorButton}
        onChange={e => {
         setFloorButton(e.target.value);
        }}
       >
        <option value='roof'>{langContext == 'en' ? 'Roof Floor' : 'Etage 3'}</option>
        <option value='second'>{langContext == 'en' ? 'Second Floor' : 'Etage 2'}</option>
        <option value='first'>{langContext == 'en' ? 'First Floor' : 'Etage 1'}</option>
       </select>
      </div>
     </div>
    </div>
   </section>
   <section id='idThreeD' className='  bg-backbg   xg-blue-500 flex flex-col items-center justify-center md:pt-[14vh]  h-full min-h-[300px]  w-full md:w-1/2  '>
    <div className='h-[40vh] flex items-center justify-center  w-full px-[5vw] min-h-[300px] md:h-[60vh]   md:px-[40px] md:min-h-[300px] '>
     <Suspense fallback={<Loading />}>
      <ThreeD cameraButton={cameraButton} floorButton={floorButton} textureButton={textureButton} />
     </Suspense>
    </div>
   </section>
  </div>
 );
}

export default TreeD;
